<ng-template #templateModal>
    <div class="modal-header">
        <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="closeVentana()">
            <span inert>&times;</span>
        </button>
    </div>

    <div class="modal-body">
        <div class="row">
            <div class="col flex3">
                <img *ngIf="accion == 'Crear' || accion == 'Editar' || accion == ''" [src]="'check.png' | imageCdn" class="succ">
                <div *ngIf="accion == 'Crear' || accion == 'Editar' || accion == ''" class="col-12 tituloModal">

                    <h3 class="accion">{{descripcion}}</h3>
                    <p *ngIf="accion == 'Crear'" class="mensaje">Creado correctamente</p>
                    <p *ngIf="accion == ''" class="mensaje">exitosamente</p>

                </div>

                <img *ngIf="accion == 'error' || accion == 'tokenExpired'" [src]="'alerta.png' | imageCdn" style="margin-top: -30px;">
                <div *ngIf="accion == 'error'" class="col-12 tituloModalError">
                    <p style="color: #707070;">{{descripcion}}</p>
                    <button style="margin-bottom: 35px;" class="boton" type="button" (click)="closeVentana()">Aceptar</button>
                </div>

                <!-- token vencido -->
                <div *ngIf="accion == 'tokenExpired'" class="col-12 tituloModalExpiredToken">
                    <p style="color: #6b4b8b; margin-top: 16px !important; font-size: 20px; font-weight: 600;">{{descripcion}}</p>
                    <p style="font-size: 19px; margin-bottom: 12px !important; color: #707070; font-weight: 600;">ingrese nuevamente</p>
                    <button style="margin-bottom: 35px;" class="boton" type="button" (click)="out()">Aceptar</button>
                </div>

                <img *ngIf="accion == 'noDatos'" [src]="'alerta.png' | imageCdn" style="margin-top: -30px;">
                <div *ngIf="accion == 'noDatos'" class="col-12 tituloModalNodatos">
                    <p style="font-size: 25px !important">{{descripcion}}</p>
                    <button class="boton btnAceptar" type="button" (click)="closeVentana()">Aceptar</button>
                </div>
            </div>
        </div>
    </div>
</ng-template>
